import MyExpApi from "apps/myExperience/enum/MyExpApi";
import { QueryClient } from "react-query";
import { useCopies } from "shared/hooks/useCopies";
import { successToast } from "shared/utils/toastNotification";
import { ApiRegistrationParticipantProfilePicture } from "shared/types/ApiRegistrationParticipantProfilePicture";
import { usePostApiData } from "shared/datalayer";
import { getDashboardQueryKey } from "../../context/dashboard/dataloader";
import { updateProfilePictureInParticipantDetails } from "apps/myExperience/context/participantDetails/dataloader";

export function useUploadImage(regParticipantId?: string, uiVersion?: number) {
  const copies = useCopies();
  return usePostApiData<ApiRegistrationParticipantProfilePicture, FormData>(MyExpApi.UPLOAD_PROFILE_IMAGE, {
    clientOptions: {
      params: {
        id: regParticipantId,
        uiVersion
      },
      trimAndRemoveNull: false
    },
    onSuccess: () => {
      successToast(copies.get("profile.image.uploaded"));
    }
  });
}

export function updateDashboardWithProfilePicture(
  queryClient: QueryClient,
  uploadResponse: ApiRegistrationParticipantProfilePicture
) {
  const queryKey = getDashboardQueryKey(uploadResponse.id);
  queryClient.setQueryData(queryKey, (data: any) => {
    return {
      ...data,
      profilePictureLocation: uploadResponse.profilePictureLocation,
      uiVersion: uploadResponse.uiVersion
    };
  });
  //Also update in participant api
  updateProfilePictureInParticipantDetails(queryClient, uploadResponse);
}
